export var isVolumeValueCheck = function isVolumeValueCheck(type, volume) {
  return type === 'up' ? volume < 1 : volume > 0;
};
export var getVolumeNewValue = function getVolumeNewValue(type, volume, soundStep) {
  return type === 'up' ? Number((volume + soundStep).toFixed(1)) : Number((volume - soundStep).toFixed(1));
};